import { CHART_IDS, isDashboardChartMockEnabled } from "../../../config/featureConfig";
import { apiVendorStatsProvider } from "./apiVendorStatsProvider";
import { mockVendorStatsProvider } from "./mockVendorStatsProvider";

export const vendorStatsProvider = {
  getTopProductsByClick: async (request) => {
    const impl = isDashboardChartMockEnabled(CHART_IDS.TOP_PRODUCTS_BY_CLICK)
      ? mockVendorStatsProvider
      : apiVendorStatsProvider;
    return impl.getTopProductsByClick(request);
  },

  getVendorTraffic: async (request) => {
    const impl = isDashboardChartMockEnabled(CHART_IDS.DAILY_TRAFFIC)
      ? mockVendorStatsProvider
      : apiVendorStatsProvider;
    return impl.getVendorTraffic(request);
  },

  getTopCategoriesByClick: async (request) => {
    const impl = isDashboardChartMockEnabled(CHART_IDS.TOP_CATEGORIES_BY_SEARCH)
      ? mockVendorStatsProvider
      : apiVendorStatsProvider;
    return impl.getTopCategoriesByClick(request);
  },
};
